import actionCreator from 'helpers/actionCreator'

export const ADD_MARKUP = 'ADD_MARKUP'
export const UPDATE_MARKUP = 'UPDATE_MARKUP'
export const DELETE_MARKUP = 'DELETE_MARKUP'
export const SET_CURRENT_MARKUP = 'SET_CURRENT_MARKUP'

export const addMarkupAction = actionCreator(ADD_MARKUP, 'markupType', 'overlay', 'copy')
export const updateMarkupAction = actionCreator(UPDATE_MARKUP, 'id', 'updates')
export const deleteMarkupAction = actionCreator(DELETE_MARKUP, 'id')
export const setCurrentMarkupAction = actionCreator(SET_CURRENT_MARKUP, 'id', 'markupType')



// WEBPACK FOOTER //
// ./src/actions/markupActions.js